import { makeAutoObservable } from 'mobx';
import { getObject } from '../utils/helpers';

class Config {
    apiError = '';
    apiErrorCode = 0;
    apiSuccess = '';
    loading = false;

    constructor() {
        makeAutoObservable(this);
    }

    // Update or add a single key-value pair
    updateValue = (key, value) => {
        (this)[key] = value;
    }

    // Update or add multiple key-value pairs
    updateMultiValue = (values) => {
        Object.keys(getObject(values)).forEach((key) => {
            (this)[key] = values[key];
        });
    }

    reset = () => {
        this.apiError = '';
        this.apiErrorCode = 0;
        this.apiSuccess = '';
        this.loading = false;
    }
}
const config = new Config();
export default config;
